<template>
    <div class="page-container">
        <!--工具栏-->
        <div class="toolbar" style="float:left;padding-top:10px;padding-left:15px;text-align:left">
            <el-form :inline="true" :model="filters" :size="size">
                <el-form-item label="数据ID">
                    <el-input
                        type="number"
                        style="width:140px"
                        v-model="filters.dataId"
                        @mousewheel.native.prevent
                        placeholder="请输入数据ID"
                    >
                    </el-input>
                </el-form-item>
<!--                <el-form-item label="年份">-->
<!--                    <el-select-->
<!--                    clearable-->
<!--                    multiple collapse-tags-->
<!--                    @clear='clearYear'-->
<!--                    @change="searchJonitList"-->
<!--                    v-model="filters.dataYearArray"-->
<!--                    placeholder="请选择年份"-->
<!--                    style="width:140px">-->
<!--                        <el-option-->
<!--                            v-for="item in years"-->
<!--                            :key="item + 1"-->
<!--                            :label="item"-->
<!--                            :value="item">-->
<!--                        </el-option>-->
<!--                    </el-select>-->
<!--                </el-form-item>-->
                <el-form-item label="省份" prop="provinceId">
                    <el-select
                    clearable
                    @change="searchJonitList"
                    @clear='clearProv'
                    v-model="filters.provinceId"
                    placeholder="请选择省份"
                    style="width:140px">
                        <el-option
                            v-for="item in provinceList"
                            :key="item.provinceId + 2"
                            :label="item.provinceShortName"
                            :value="item.provinceId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="统考类别" prop="jointCategoryId">
                    <el-select
                    v-model="filters.jointCategoryId"
                    :placeholder="jointList.length>0?'请选择统考专业':'请先选择年份和省份'"
                    style="width:140px">
                        <el-option
                            v-for="item in jointList"
                            :key="item.jointCategoryId"
                            :label="item.jointCategoryName"
                            :value="item.jointCategoryId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="院校" prop="schoolId">
                    <el-select
                        remote
                        filterable
                        clearable
                        @clear = 'clearSchool'
                        @change="$forceUpdate()"
                        :remote-method="getSchoolList"
                        v-model="filters.schoolId"
                        placeholder="请输入院校名称"
                        style="width:140px">
                        <el-option
                            v-for="item in schoolList"
                            :key="item.schoolId+3"
                            :label="item.schoolName"
                            :value="item.schoolId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <perm-button
                        icon="fa fa-search"
                        label="搜索"
                        perms="sch:examType:list"
                        type="primary"
                        @click="findPage({pageRequest:{current: 1,size: 10}})"/>
                </el-form-item>
                <el-form-item>
                    <perm-button
                        icon="fa fa-plus"
                        label="新增"
                        perms="sch:examType:add"
                        type="success"
                        @click="handleAdd"/>
                </el-form-item>
                <el-form-item>
                    <perm-button icon="el-icon-upload2" label="导入" perms="sch:examType:import" type="warning" @click="handleImport"/>
                </el-form-item>
                <el-form-item>
                    <perm-button icon="el-icon-download" label="导出" perms="sch:examType:export" type="danger" @click="handleExport"/>
                </el-form-item>
                <el-form-item>
                    <perm-button icon="el-icon-upload" label="批量更新" perms="sch:examType:batchUpdate" type="success" @click="handleUpdata"/>
                </el-form-item>
                <el-form-item>
                    <perm-button icon="el-icon-delete" label="批量删除" perms="sch:examType:batchDelete" type="danger" @click="handleQueryDel"/>
                </el-form-item>
                <el-form-item>
                    <el-button icon="el-icon-setting" label="" size="small" type="primary" @click="handleSetExport">选择导出字段</el-button>
                </el-form-item>
<!--                <el-form-item>-->
<!--                    <perm-button icon="el-icon-check" label="校验统校考类型" perms="sch:examType:check" type="warning" @click="handleCheckDialog"/>-->
<!--                </el-form-item>-->
            </el-form>
        </div>
        <div class="toolbar" style="float:right;padding-top:10px;padding-right:15px;">
            <!--表格显示列界面-->
        </div>
        <table-column-filter-dialog
            ref="tableColumnFilterDialog"
            :columns="columns"
            @handleFilterColumns="handleFilterColumns">
        </table-column-filter-dialog>
        <!--表格树内容栏-->
        <perm-table
            :page="page"
            :columns="columns"
            :selectionChange="selectionChange"
            :handleCurrentHandle="handleCurrentHandle"
            :loading="loading"
            size="mini"
            @findPage="findPage"
            :showOperation='true'
            @handleEdit="handleEdit"
            @handleDelete="handleDelete"
            permsEdit="sch:examType:update"
            permsDelete="sch:examType:delete">
        </perm-table>
        <el-dialog :title="!dataForm.dataId ? '新增校考院校分省信息' : '编辑校考院校分省信息'" width="60%" :visible.sync="dialogVisible" :close-on-click-modal="false" @close='cancel'>
            <el-form
                :model="dataForm"
                :rules="dataRule"
                ref="dataForm"
                @keyup.enter.native="submitForm"
                label-width="140px"
                :size="size"
                style="text-align:left;">
                <el-row>
                    <el-col :span="10">
                        <el-form-item label="年份" prop="dataYear">
                            <el-select
                            clearable
                            @clear='clearDataYear'
                            @change="getJonitList"
                            v-model="dataForm.dataYear"
                            placeholder="请选择年份"
                            style="width:200px">
                                <el-option
                                    v-for="item in years"
                                    :key="item + 4"
                                    :label="item"
                                    :value="item">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="省份" prop="provinceId">
                            <el-select
                            clearable
                            @change="getJonitList"
                            @clear='clearProvince'
                            v-model="dataForm.provinceId"
                            placeholder="请选择省份"
                            style="width:200px">
                                <el-option
                                    v-for="item in provinceList"
                                    :key="item.provinceId + 5"
                                    :label="item.provinceShortName"
                                    :value="item.provinceId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="10">
                        <el-form-item label="院校" prop="schoolId">
                            <el-select
                                remote
                                filterable
                                clearable
                                @clear = 'clearSchoolId'
                                @change="$forceUpdate()"
                                :remote-method="getSchoolList"
                                v-model="dataForm.schoolId"
                                placeholder="请输入院校名称"
                                style="width:200px">
                                <el-option
                                    v-for="item in schoolList"
                                    :key="item.schoolId"
                                    :label="item.schoolName"
                                    :value="item.schoolId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="统考类别" prop="jointCategoryId">
                            <el-select
                            v-model="dataForm.jointCategoryId"
                            :placeholder="jointList1.length>0?'请选择统考专业':'请先选择年份和省份'"
                            style="width:200px">
                                <el-option
                                v-for="item in jointList1"
                                :key="item.jointCategoryId"
                                :label="item.jointCategoryName"
                                :value="item.jointCategoryId">
                                </el-option>
                            </el-select>
                            <!-- <el-select
                                remote
                                filterable
                                clearable
                                @clear = 'clearCate'
                                :remote-method="getCateList"
                                v-model="dataForm.jointCategoryId"
                                placeholder="请输入统考类别"
                                style="width:200px">
                                <el-option
                                    v-for="item in cateList"
                                    :key="item.jointCategoryId"
                                    :label="item.jointCategoryName"
                                    :value="item.jointCategoryId">
                                </el-option>
                            </el-select> -->
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="10">
                        <el-form-item label="统校考类型" prop="examType">
                            <el-select clearable @clear='clearType' v-model="dataForm.examType" placeholder="请选择统校考类型" style="width:200px">
                                <el-option
                                    v-for="item in examTypeList"
                                    :key="item.value+14"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="下一年是否变动" prop="examTypeChange">
                            <el-select clearable @clear='clearChange' v-model="dataForm.examTypeChange" placeholder="请选择是否变动" style="width:200px">
                                <el-option
                                    v-for="item in changeList"
                                    :key="item.value+14"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="10">
                        <el-form-item label="报名开始时间" prop="startTime">
                            <el-date-picker
                                v-model="dataForm.startTime"
                                type="datetime"
                                style="width:200px"
                                placeholder="请选择报名开始时间">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="报名结束时间" prop="endTime">
                            <el-date-picker
                                v-model="dataForm.endTime"
                                type="datetime"
                                style="width:200px"
                                placeholder="请选择报名结束时间">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <!-- <el-form-item label="报名时间">
                        <el-date-picker
                            style="width:562px"
                            v-model="time"
                            type="datetimerange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            :default-time="['00:00:00', '23:59:59']"
                            >
                        </el-date-picker>
                    </el-form-item> -->
                </el-row>
                <el-row>
                    <el-col :span="10">
                        <el-form-item label="考试开始时间" prop="onlineExamStartTime">
                            <el-date-picker
                                v-model="dataForm.onlineExamStartTime"
                                type="datetime"
                                style="width:200px"
                                placeholder="请选择考试开始时间">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="考试结束时间" prop="onlineExamEndTime">
                            <el-date-picker
                                v-model="dataForm.onlineExamEndTime"
                                type="datetime"
                                style="width:200px"
                                placeholder="请选择考试结束时间">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="10">
                        <el-form-item label="报名备注" prop="remark">
                            <el-input v-model="dataForm.remark" style="width:200px" placeholder="请输入报名备注" autocomplete="off" maxlength="64"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="考试日期说明" prop="examTime">
                            <el-input v-model="dataForm.examTime" style="width:200px" @input="$forceUpdate()" placeholder="请输入考试日期说明" autocomplete="off" maxlength="64"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="10">
                        <el-form-item label="报名状态">
                            <el-select v-model="dataForm.applyStatus" placeholder="请选择报名状态" style="width:200px">
                                <el-option
                                    v-for="item in statusList"
                                    :key="item.value+14"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="线上特殊说明" prop="onlineSchoolRemark">
                            <el-input v-model="dataForm.onlineSchoolRemark" @input="$forceUpdate()" style="width:200px" placeholder="请输入线上特殊说明" autocomplete="off" maxlength="64"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="10">
                        <el-form-item label="序号" prop="orderNum">
                            <el-input type="number" @mousewheel.native.prevent @DOMMouseScroll.native.prevent v-model="dataForm.orderNum" style="width:200px" placeholder="请输入序号" autocomplete="off" maxlength="64"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-form-item label="线上院校资讯" prop="onlineSchoolInfoUrl">
                        <!-- <el-input  style="width:200px" type="textarea" :rows=3 v-model="dataForm.onlineSchoolInfoUrl" placeholder="请输入线上院校资讯富文本内容"></el-input> -->
                        <div id="editor1"></div>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="校考信息资讯" prop="examInfo">
                        <!-- <el-input  style="width:200px" type="textarea" :rows=3 v-model="dataForm.examInfo" placeholder="请输入校考信息资讯富文本内容"></el-input> -->
                        <div id="editor2"></div>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="考试科目资讯" prop="subject">
                        <!-- <el-input  style="width:200px" type="textarea" :rows=3 v-model="dataForm.subject" placeholder="请输入考试科目资讯富文本内容"></el-input> -->
                        <div id="editor3"></div>
                    </el-form-item>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button :size="size"  @click="cancel">取消</el-button>
                <el-button :size="size"  type="primary" :loading="editLoading" @click="submitForm">确认</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="showTemplate" width="90%" title="配置导出字段">
            <div style="display:flex;justify-content: space-around;flex-flow: wrap;" >
                <div class="mar-right" :class="index==options.length-1 ?'magin-0':''" v-for="(item,index) in options" :key="index">
                    <div style="margin-bottom:15px">{{item.chName}}</div>
                    <div>
                        <el-checkbox v-model="item.selected">{{item.engName}}</el-checkbox>
                    </div>
                </div>
            </div>
            <div>
                <div style="display:flex;justify-content:flex-end;padding:6px 60px 0 0">
                    <div>
                        <el-button class='selectall' @click="selectAllItem">全选</el-button>
                        <el-button class='cancelselect' @click="cancelSelectAllItem">取消全选</el-button>
                    </div>
                </div>
                <div class="footer-box">
                    <el-button @click='cancelOperation'>取消</el-button>
                    <el-button @click='finishSet'>确定</el-button>
                    <el-button @click='produceTemp'>生成导入模板</el-button>
                </div>
            </div>
        </el-dialog>
        <div v-if="importDialog">
            <import-component
                :importitle="'校考院校分省信息导入'"
                :importType='50'
                :importableId = '10'
                :isSchTxExamType = 'true'
                @handleSetExport = 'handleSetExport'
                @closeImport = 'closeImport'
            >
            </import-component>
        </div>
        <div v-if="DeleteVisible">
            <query-delete
                :exportType='50'
                :tableId="10"
                :isSchTxExamType = 'true'
                :title='"校考院校分省信息批量删除"'
                @hideDialog='closeDelete'>
            </query-delete>
        </div>
        <!-- 批量更新 -->
        <div v-if="showUpdata">
            <batch-update
                :importitle="'校考院校分省信息批量更新'"
                :importType='70'
                :importableId = '10'
                :isSchTxExamType = 'true'
                @closeImport = 'closeUpdata'
            >
            </batch-update>
        </div>
        <div v-if="showExport">
            <province-stat-data
                :exportType='30'
                :exportBatch ='50'
                :tableId="10"
                :dataIDFlag='true'
                :isSchTxExamType='true'
                :exportBartchFlag='true'
                :dataYearFlag='true'
                :provinceFlag='true'
                :jonitFlag='true'
                :schoolFlag='true'
                :title='"校考院校分省信息导出"'
                :fileName='fileNames'
                @hideDialog='hideDialog'>
            </province-stat-data>
        </div>
    </div>
</template>

<script>
import PopupTreeInput from '../../Component/PopupTreeInput/Index'
import PermButton from '../../Component/PermButton/Index'
import PermTable from '../../Component/PermTable/Index'
import TableColumnFilterDialog from '../../Component/TableColumnFilterDialog/Index'
import ProvinceStatData from '../../Component/ExportProvinceData/provinceStatData.vue'
import ImportComponent from '../../Component/ImportData/Index'
import BatchUpdate from '../../Component/batchUpdate/Index.vue'
import QueryDelete from '../../Component/QueryDelete/index.vue'
import MyCustomUploadAdapterPlugin from '@/utils/uploadAdapter'

export default {
    name: 'Schoolexamcalendar',
    components: {
        PermTable,
        PermButton,
        PopupTreeInput,
        TableColumnFilterDialog,
        ProvinceStatData,
        ImportComponent,
        BatchUpdate,
        QueryDelete
    },
    data: function() {
        return {
            size: 'small',
            loading: false,
            importDialog: false,
            DeleteVisible: false,
            showExport: false,
            showUpdata: false,
            showTemplate: false,
            showCheckFlag: false,
            selectDataYear: '',
            editor1: '',
            editor2: '',
            editor3: '',
            fileNames: [],
            fieldNames: [],
            provinceList: [],
            filters: {
                dataId: '',
                dataYearArray: [],
                provinceId: '',
                jointCategoryId: '',
                schoolId: ''
            },
            filterColumns: [],
            columns: [],
            page: {},
            pageRequest: {
                current: 1,
                size: 10
            },
            jointList: [],
            jointList1: [],
            jointList2: [],
            editLoading: false,
            dialogVisible: false,
            dataForm: {
                dataId: null,
                dataYear: null,
                provinceId: null,
                provinceName: null,
                jointCategoryId: null,
                jointCategoryName: null,
                schoolId: null,
                schoolName: null,
                examType: null,
                examTypeChange: null,
                startTime: null,
                endTime: null,
                onlineExamStartTime: null,
                onlineExamEndTime: null,
                remark: null,
                applyStatus: null,
                orderNum: null,
                examTime: null,
                onlineSchoolRemark: null,
                onlineSchoolInfoUrl: null,
                examInfo: null,
                subject: null
                // schoolExamInfoUrl: null,
                // schoolSubjectInfoUrl: null
            },
            checkForm: {
                dataYear: null,
                provinceId: null,
                jointCategoryId: null,
                schoolId: null
            },
            dataRule: {
                dataYear: [{ required: true, message: '数据年份不能为空', trigger: 'blur' }],
                provinceId: [{ required: true, message: '省份不能为空', trigger: 'change' }],
                jointCategoryId: [{ required: true, message: '统考类别不能为空', trigger: 'change' }],
                schoolId: [{ required: true, message: '院校不能为空', trigger: 'change' }],
                examType: [{ required: true, message: '统校考类别不能为空', trigger: 'change' }]
                // startTime: [{ required: true, message: '考试开始时间不能为空', trigger: 'change' }],
                // endTime: [{ required: true, message: '考试结束时间不能为空', trigger: 'change' }],
            },
            checkRule: {
                dataYear: [{ required: true, message: '数据年份不能为空', trigger: 'blur' }]
            },
            options: [],
            importPar: {
                tableId: 10,
                importBatch: '',
                filePath: '',
                originName: ''
            },
            years: [2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025],
            // cateList:[],
            // searchjointCategory: {
            //     keywords: ''
            // },
            searchSchool: {
                keywords: ''
            },
            searchCheckSchool: {
                keywords: ''
            },
            schoolList: [],
            checkSchoolList: [],
            examTypeList: [
                { label: '统考及校考', value: 1 },
                { label: '仅统考', value: 2 },
                { label: '仅校考', value: 3 }
            ],
            changeList: [
                { label: '是', value: 1 },
                { label: '否', value: 0 }
            ],
            statusList: [
                { label: '报名开始', value: 1 },
                { label: '未开始', value: 2 },
                { label: '已结束', value: 3 },
                { label: '未公布', value: 4 }
            ]
        }
    },
    methods: {
        cancel: function() {
            this.dialogVisible = false
            this.$refs.dataForm.resetFields()
            this.editor1.setData('')
            this.editor2.setData('')
            this.editor3.setData('')
            this.setDefaultYears()
        },
        cancelCheck() {
            this.showCheckFlag = false
            this.$refs.checkForm.resetFields()
        },
        // // 提交校验院校
        // checkSubmit() {
        //     var callback = (res) => {
        //         this.editLoading = false
        //         if (res.success) {
        //             if (res.data) {
        //                 this.$message({ message: '校验成功', type: 'success' })
        //                 this.$refs['checkForm'].resetFields()
        //                 this.showCheckFlag = false
        //             } else {
        //                 this.$message({ message: '暂无数据', type: 'warning' })
        //             }
        //         } else {
        //             this.$message({
        //                 message: res.message,
        //                 type: 'error'
        //             })
        //         }
        //     }
        //     this.$refs['checkForm'].validate(valid => {
        //         if (valid) {
        //             this.$confirm('确认提交吗？', '提示', {}).then(() => {
        //                 this.editLoading = true
        //                 const params = Object.assign({}, this.checkForm)
        //                 console.log(JSON.stringify(params))
        //                 this.$api.TxExamType.checkSchoolType(params).then(res => {
        //                     callback(res)
        //                 })
        //             })
        //         }
        //     })
        // },
        handleCheckDialog() {
            this.showCheckFlag = true
        },
        getSchoolList(params) {
            console.log(params)
            if (params !== '') {
                this.searchSchool.keywords = params
                this.$api.ZlInfo.getSchoolList(this.searchSchool).then(res => {
                    if (res && !res.success) {
                        this.$message({ message: res.message, type: 'error' })
                        return
                    }
                    this.schoolList = res.data
                })
            }
        },
        getCheckSchoolList(params) {
            console.log(params)
            if (params !== '') {
                this.searchCheckSchool.keywords = params
                this.$api.ZlInfo.getSchoolList(this.searchCheckSchool).then(res => {
                    if (res && !res.success) {
                        this.$message({ message: res.message, type: 'error' })
                        return
                    }
                    this.checkSchoolList = res.data
                })
            }
        },
        // //获取专业列表
        searchJonitList() {
            debugger
            this.getNewYear()
            // this.dataForm.jointCategoryId = ''
            this.filters.jointCategoryId = null
            this.jointList = []
            if (this.filters.provinceId && this.selectDataYear) {
                const params = {
                    dataYear: this.selectDataYear,
                    provinceId: this.filters.provinceId
                }
                this.$api.Tkinfo.getJointListByParam(params).then(res => {
                    if (res && !res.success) {
                        this.$message({ message: res.message, type: 'error' })
                        return
                    }

                    this.jointList = res.data
                    if (this.jointList.length > 0) {
                        this.filters.jointCategoryId = this.jointList[0].jointCategoryId
                    }
                    if (this.jointList.length === 0) {
                        this.filters.jointCategoryId = null
                    }
                })
            }
        },
        getJonitList() {
            debugger
            if (this.dataForm.provinceId && this.dataForm.dataYear) {
                const params = {
                    dataYear: this.dataForm.dataYear,
                    provinceId: this.dataForm.provinceId
                }
                this.$api.Tkinfo.getJointListByParam(params).then(res => {
                    if (res && !res.success) {
                        this.$message({ message: res.message, type: 'error' })
                        return
                    }

                    this.jointList1 = res.data
                    if (this.jointList1.length === 1) {
                        this.dataForm.jointCategoryId = this.jointList1[0].jointCategoryId
                    }
                    if (this.jointList1.length === 0) {
                        this.dataForm.jointCategoryId = null
                    }
                })
            }
        },
        getJonitList2() {
            debugger
            if (this.checkForm.provinceId && this.checkForm.dataYear) {
                const params = {
                    dataYear: this.checkForm.dataYear,
                    provinceId: this.checkForm.provinceId
                }
                this.$api.Tkinfo.getJointListByParam(params).then(res => {
                    if (res && !res.success) {
                        this.$message({ message: res.message, type: 'error' })
                        return
                    }

                    this.jointList2 = res.data
                    if (this.jointList2.length === 1) {
                        this.checkForm.jointCategoryId = this.jointList2[0].jointCategoryId
                    }
                    if (this.jointList2.length === 0) {
                        this.checkForm.jointCategoryId = null
                    }
                })
            }
        },
        submitForm() {
            var callback = (res) => {
                this.editLoading = false
                if (res.success) {
                    this.$message({ message: '操作成功', type: 'success' })
                    this.$refs['dataForm'].resetFields()
                    this.dialogVisible = false
                    // 当前页
                    this.findPage(null)
                } else {
                    this.$message({
                        message: res.message,
                        type: 'error'
                    })
                }
            }
            this.$refs['dataForm'].validate(valid => {
                if (valid) {
                    this.$confirm('确认提交吗？', '提示', {}).then(() => {
                        this.editLoading = true
                        const params = Object.assign({}, this.dataForm)
                        params.onlineSchoolInfoUrl = this.editor1.getData()
                        params.examInfo = this.editor2.getData()
                        params.subject = this.editor3.getData()
                        if (this.dataForm.startTime) {
                            var startNum = new Date(this.dataForm.startTime).getTime()
                        }
                        if (this.dataForm.startTime) {
                            var endNum = new Date(this.dataForm.endTime).getTime()
                        }
                        if (this.dataForm.startTime && this.dataForm.endTime) {
                            if (startNum > endNum) {
                                this.$message({ message: '报名结束时间不能小于报名开始时间，请选择正确时间', type: 'warning' })
                                this.editLoading = false
                                return
                            }
                        }
                        if (this.dataForm.onlineExamStartTime) {
                            var onlineStartNum = new Date(this.dataForm.onlineExamStartTime).getTime()
                        }
                        if (this.dataForm.onlineExamEndTime) {
                            var onlineEndNum = new Date(this.dataForm.onlineExamEndTime).getTime()
                        }
                        if (this.dataForm.onlineExamStartTime && this.dataForm.onlineExamEndTime) {
                            if (onlineStartNum > onlineEndNum) {
                                this.$message({ message: '考试结束时间不能小于考试开始时间，请选择正确时间', type: 'warning' })
                                this.editLoading = false
                                return
                            }
                        }
                        if (!this.dataForm.dataId) {
                            this.$api.TxExamType.addSchTxExamType(params).then(res => {
                                callback(res)
                            })
                        } else {
                            this.$api.TxExamType.editSchTxExamType(params).then(res => {
                                callback(res)
                            })
                        }
                    })
                }
            })
        },
        clearYear() {
            this.filters.dataYear = ''
        },
        clearProv() {
            this.filters.provinceId = ''
        },
        clearSchool() {
            this.filters.schoolId = ''
        },
        clearJoint() {
            this.filters.jointCategoryId = ''
        },
        clearDataYear() {
            this.dataForm.dataYear = null
        },
        clearProvince() {
            this.dataForm.provinceId = null
        },
        clearSchoolId() {
            this.dataForm.schoolId = null
        },
        clearCate() {
            this.dataForm.jointCategoryId = null
        },
        clearType() {
            this.dataForm.examType = null
        },
        clearChange() {
            this.dataForm.examTypeChange = null
        },
        clearStartTime() {
            console.log(this.dataForm.startTime)
        },
        handleDelete(data) {
            this.$confirm('确认删除选中记录吗？', '提示', {
                type: 'warning'
            }).then(() => {
                const params = this.getDeleteIds([], data.row)
                this.$api.TxExamType.deleteSchTxExamType(params).then(res => {
                    if (!res.success) {
                        this.$message({ message: res.message, type: 'error' })
                        return
                    }
                    this.$message({ message: '删除成功', type: 'success' })
                    this.findPage(null)
                })
            })
        },
        // 获取删除的统考id
        getDeleteIds(ids, row) {
            console.log(row)
            debugger
            ids.push(row.dataId)
            if (row.children != null) {
                for (let i = 0, len = row.children.length; i < len; i++) {
                    this.getDeleteIds(ids, row.children[i])
                }
            }
            return ids
        },
        handleEdit(data) {
            const param = {
                dataId: data.row.dataId
            }
            this.$api.TxExamType.getSchTxExamType(param).then(res => {

                Object.assign(this.dataForm, res.data)
                this.getJonitList()
                // var examSDate = new Date(res.data.startTime)
                // var examEDate = new Date(res.data.endTime)
                // var syear = examSDate.getFullYear()
                // var smonth = examSDate.getMonth()
                // var sday = examSDate.getDate()
                // var shours = examSDate.getHours()
                // var smin = examSDate.getMinutes()
                // var ssecond = examSDate.getSeconds()
                // var eyear = examEDate.getFullYear()
                // var emonth = examEDate.getMonth()
                // var eday = examEDate.getDate()
                // var ehours = examEDate.getHours()
                // var emin = examEDate.getMinutes()
                // var esecond = examEDate.getSeconds()
                // this.time = [new Date(syear,smonth,sday,shours,smin,ssecond),new Date(eyear,emonth,eday,ehours,emin,esecond)]
                // console.log(this.time)
                this.getSchoolList(res.data.schoolName)
                this.initEditor({
                    onlineSchoolInfoUrl: res.data.onlineSchoolInfoUrl,
                    examInfo: res.data.examInfo,
                    subject: res.data.subject
                })
                // this.getCateList(res.data.jointCategoryName)
            })
            this.dialogVisible = true
        },
        handleAdd() {
            this.dialogVisible = true
            this.dataForm = {
                dataYear: '',
                provinceId: '',
                provinceName: '',
                jointCategoryId: '',
                jointCategoryName: '',
                schoolId: '',
                schoolName: '',
                examType: '',
                examTypeChange: '',
                startTime: '',
                endTime: '',
                remark: '',
                applyStatus: '',
                orderNum: ''
            }
            this.initEditor()
            this.setDefaultYears()
        },
        handleImport() {
            this.importDialog = true
        },
        // 导出
        handleExport() {
            this.showExport = true
        },
        closeDelete() {
            this.DeleteVisible = false
        },
        handleQueryDel() {
            this.DeleteVisible = true
        },
        // 批量更新
        handleUpdata() {
            this.showUpdata = true
        },
        hideDialog() {
            this.showExport = false
        },
        handleSetExport() {
            this.showTemplate = true
        },
        cancelOperation() {
            this.showTemplate = false
        },
        finishSet() {
            this.getFileNames()
            this.showTemplate = false
        },
        closeImport() {
            this.importDialog = false
        },
        closeUpdata() {
            this.showUpdata = false
        },
        // 根据选择字段，生成模板
        produceTemp() {
            this.getFileNames()
            if (this.fileNames.length > 0) {
                let str = ''
                let url = ''
                this.fileNames.forEach((item, index) => {
                    if (index === 0) {
                        str = 'fieldNames=' + item
                    } else {
                        str = str + '&fieldNames=' + item
                    }
                })
                console.log(str)
                url = 'https://testbase.lpswish.com/api/base/download/excel/template' + '?' + `tableId=${this.importPar.tableId}` + '&title=' + '校考院校分省信息导入模板&' + str
                const xhr = new XMLHttpRequest()
                var that = this
                xhr.onreadystatechange = function() {
                    if (xhr.readyState === 4) {
                        if (xhr.status === 200) {
                            console.log(xhr)
                            window.open(url)
                        } else {
                            const res = JSON.parse(xhr.response)
                            that.$message({ message: res.data.error, type: 'error' })
                            return
                        }
                    } else {
                        /* 暂不处理*/
                    }
                }
                xhr.open('get', url)
                xhr.send()
            } else {
                this.$message({ message: '请选择生成模板字段', type: 'warning' })
            }
        },
        getFileNames() {
            debugger
            this.options.forEach((item, index) => {
                // debugger
                if (item.selected && this.fileNames.indexOf(item.engName) === -1) {
                    this.fileNames.push(item.engName)
                } else if (!item.selected) {
                    if (this.fileNames.indexOf(item.engName) !== -1) {
                        const index = this.fileNames.indexOf(item.engName)
                        this.fileNames.splice(index, 1)
                    }
                }
            })
            console.log(this.fileNames)
        },
        // 获取分页数据
        findPage: function(data) {
            this.loading = true
            if (data != null) {
                this.pageRequest = data.pageRequest
            }
            let param = {}
            debugger
            if (this.filters.dataYearArray.length > 0 || this.filters.provinceId || this.filters.schoolId || this.filters.dataId || this.filters.jointCategoryId) {
                param = Object.assign(this.filters, this.pageRequest)
            } else {
                param = Object.assign(param, this.pageRequest)
            }
            // 省份分省信息只查2023年，也就是最新一个高考年的
            param.dataYear = this.getNextYear()
            console.log(param)
            this.$api.TxExamType.searchSchTxExamTypeList(param).then(res => {
                if (res && !res.success) {
                    this.$message({ message: res.message, type: 'error' })
                    this.loading = false
                    return
                }
                this.page = res.data
                this.loading = false
            }).then(data != null ? data.callback : '')
        },
        selectionChange(selections) {
            console.log(selections)
        },
        handleCurrentHandle: function(val) {
            console.log('handleCurrentHandle>>' + val)
        },
        formatAppstatus(q, w, row) {
            var text
            w.renderCell = (h, params) => {
                switch (params.row.applyStatus) {
                    case 1:
                        text = '报名开始'
                        break
                    case 2:
                        text = '未开始'
                        break
                    case 3:
                        text = '已结束'
                        break
                    case 4:
                        text = '未公布'
                        break
                    default:
                        text = ''
                        break
                }
                return h('span', text)
            }
        },
        formatExamTypeChange(q, w, row) {
            var text
            w.renderCell = (h, params) => {
                switch (params.row.examTypeChange) {
                    case 0:
                        text = '否'
                        break
                    case 1:
                        text = '是'
                        break
                    default:
                        text = ''
                        break
                }
                return h('span', text)
            }
        },
        // 初始化表格
        initColumns: function() {
            this.columns = [
                { prop: 'dataId', label: '数据ID', minWidth: 80 },
                { prop: 'dataYear', label: '年份', minWidth: 50 },
                { prop: 'provinceName', label: '省份名称', minWidth: 70 },
                { prop: 'jointCategoryName', label: '统考类别名称', minWidth: 110 },
                { prop: 'schoolName', label: '院校名称', minWidth: 100 },
                { prop: 'examType', label: '统校考类型', minWidth: 90 },
                { prop: 'examTypeChange', label: '下一年是否变动', minWidth: 120, formatter: this.formatExamTypeChange },
                { prop: 'startTime', label: '校考报名开始时间', minWidth: 130 },
                { prop: 'endTime', label: '校考报名结束时间', minWidth: 130 },
                { prop: 'applyStatus', label: '报名状态排序', minWidth: 110, formatter: this.formatAppstatus },
                { prop: 'remark', label: '备注信息', minWidth: 80 },
                { prop: 'orderNum', label: '序号', minWidth: 60 }
            ]
            this.filterColumns = JSON.parse(JSON.stringify(this.columns))
        },
        // 处理表格列过滤显示
        displayFilterColumnsDialog: function() {
            this.$refs.tableColumnFilterDialog.setDialogVisible(true)
        },
        // 处理表格列过滤显示
        handleFilterColumns: function(data) {
            this.filterColumns = data.filterColumns
            this.$refs.tableColumnFilterDialog.setDialogVisible(false)
        },
        setDefaultYears() {
            var date = new Date()
            if (date.getMonth() + 1 > 8) {
                // this.searchByKeyword.dataYear =  date.getFullYear() + 1
                this.dataForm.dataYear = date.getFullYear() + 1
            } else {
                this.dataForm.dataYear = date.getFullYear()
                // this.searchByKeyword.dataYear = date.getFullYear()
            }
        },
        selectAllItem() {
            this.options.forEach(item => {
                if (!item.selected) {
                    item.selected = true
                }
            })
            console.log(this.options)
        },
        cancelSelectAllItem() {
            this.options.forEach(item => {
                if (item.selected) {
                    item.selected = false
                }
            })
        },
        getNewYear() {
            if (this.filters.dataYearArray && this.filters.dataYearArray.length > 0) {
                this.filters.dataYearArray.sort(function(a, b) {
                    return a - b
                })
                this.selectDataYear = this.filters.dataYearArray[this.filters.dataYearArray.length - 1]
            } else {
                this.selectDataYear = ''
                this.jointList = []
            }
        },
        getOptionList() {
            const param = {
                tableId: this.importPar.tableId
            }
            this.$api.Tkinfo.getOptionList(param).then(res => {
                if (res.success) {
                    res.data.forEach(item => {
                        const optionItem = {
                            chName: item.columnDesc,
                            engName: item.columnName,
                            selected: false
                        }
                        this.options.push(optionItem)
                    })
                } else {
                    this.$message({
                        message: res.message
                    })
                    return
                }
            })
        },
        getNextYear() {
            var curYear = new Date()
            const fullYear = curYear.getFullYear()
            const month = curYear.getMonth() + 1
            return month > 8 ? fullYear + 1 : fullYear
        },
        initEditor(con) {
            const { ClassicEditor } = window
            const config = {
                language: 'zh-cn',
                extraPlugins: [MyCustomUploadAdapterPlugin]
            }
            this.$nextTick(() => {
                if (this.editor1) {
                    let content = ''
                    if (con && con.onlineSchoolInfoUrl) {
                        content = con.onlineSchoolInfoUrl
                    }
                    this.editor1.setData(content)
                    const contentWrap = document.querySelector('.ck-content')
                    contentWrap.scroll(0, 0)
                } else {
                    const el1 = document.getElementById('editor1')
                    ClassicEditor.create(el1, config).then((editor) => {
                        this.editor1 = editor
                        if (con && con.onlineSchoolInfoUrl) {
                            this.editor1.setData(con.onlineSchoolInfoUrl)
                        }
                    })
                }
                if (this.editor2) {
                    let content = ''
                    if (con && con.examInfo) {
                        content = con.examInfo
                    }
                    this.editor2.setData(content)
                    const contentWrap = document.querySelector('.ck-content')
                    contentWrap.scroll(0, 0)
                } else {
                    const el2 = document.getElementById('editor2')
                    ClassicEditor.create(el2, config).then((editor) => {
                        this.editor2 = editor
                        if (con && con.examInfo) {
                            this.editor2.setData(con.examInfo)
                        }
                    })
                }
                if (this.editor3) {
                    let content = ''
                    if (con && con.subject) {
                        content = con.subject
                    }
                    this.editor3.setData(content)
                    const contentWrap = document.querySelector('.ck-content')
                    contentWrap.scroll(0, 0)
                } else {
                    const el3 = document.getElementById('editor3')
                    ClassicEditor.create(el3, config).then((editor) => {
                        this.editor3 = editor
                        if (con && con.subject) {
                            this.editor3.setData(con.subject)
                        }
                    })
                }
            })
        }
    },
    mounted() {
        this.years.reverse()
        this.getOptionList()
        this.initColumns()
        this.setDefaultYears()
        this.provinceList = this.$store.state.baseProvinceList.provinceList
        this.findPage(null)
    }
}
</script>

<style scoped>
    .template-box{
        display:flex;
        padding:20px 38px 20px 50px;
    }
    .el-button--small{
        padding: 7px 15px;
    }
    .temp-child{
        margin-right:57px;
    }
    .magin-0{
        margin: 0;
    }
    .mar-right{
        margin-right: 40px;
        margin-bottom: 20px;
    }
    .footer-box{
        margin: 30px 50px 0 0;
        position: relative;
        right: 0;
    }
    .selectall{
        padding: 6px 10px;
    }
    .cancelselect{
        padding: 6px 10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Manager/Tkinfo/Schoolexamcalendar.vue